import FixedNav from "../components/Nav/FixedNav";
import MobileNav from "../components/Nav/MobileNav";
import Header from "../components/Description/Header";
import Normal from "../components/Description/Normal";
import Big from "../components/Description/Big";

const Disclaimer = () => {
  return (
    <div id="body">
      <div className="framer-IqNBt framer-vrYYp framer-NrkXy framer-l50WH framer-V74Ls framer-uKIIJ framer-Fw2Wf framer-72rtr7 min-h-screen !w-auto">
        <FixedNav />
        <MobileNav />
        <div id="content" className="w-full mt-[60px] p-[20px]">
          <Header>Disclaimer</Header>
          <div className="p-5" />
          <Big>Use of Services at Your Own Risk</Big>
          <div className="p-3" />
          <Normal>
            By accessing or using CodeBlaze’s website and Services, you
            acknowledge and agree that you are doing so at your own risk. The
            Services, including the website and any associated features, tools,
            or technologies, are provided "as is" and "as available." CodeBlaze
            makes no representations or warranties of any kind, either express
            or implied, including, but not limited to, implied warranties of
            merchantability, fitness for a particular purpose, or
            non-infringement.
          </Normal>
          <div className="p-5" />
          <Big>No Guarantee of Results or Suitability</Big>
          <div className="p-3" />
          <Normal>
            While CodeBlaze strives to provide high-quality, AI-driven code
            generation and software development tools, we make no guarantees or
            assurances regarding the outcomes of using our Services. CodeBlaze
            does not guarantee that the generated code will meet your specific
            needs or requirements, nor do we guarantee that it will be free from
            errors or security vulnerabilities. The use of generated code is at
            your sole discretion and risk, and you are responsible for
            thoroughly reviewing, testing, and modifying any code for production
            use.
          </Normal>
          <div className="p-5" />
          <Big>Accuracy and Completeness of Generated Content</Big>
          <div className="p-3" />
          <Normal>
            CodeBlaze does not guarantee the accuracy, reliability, or
            completeness of any content or code generated by the platform. All
            code generated is based on the inputs provided and may not be
            optimal or fully compatible with your environment, applications, or
            systems. CodeBlaze disclaims any responsibility for errors,
            omissions, or inaccuracies in the generated content, and it is your
            responsibility to verify and test the generated code before
            implementing it in live or production systems.
          </Normal>
          <div className="p-5" />
          <Big>Third-Party Content and Services</Big>
          <div className="p-3" />
          <Normal>
            Our Services may include links to third-party websites, tools, and
            services. These third-party sites are not controlled or operated by
            CodeBlaze, and we are not responsible for the content, accuracy, or
            functionality of such external resources. Accessing third-party
            services is done at your own risk, and CodeBlaze is not responsible
            for any issues arising from your use of these services.
          </Normal>
          <div className="p-5" />
          <Big>Service Interruptions and System Availability</Big>
          <div className="p-3" />
          <Normal>
            CodeBlaze makes no guarantees about the availability or
            uninterrupted operation of our Services. There may be periodic
            outages, system failures, or maintenance that can affect access to
            the platform. We are not liable for any loss, inconvenience, or
            damage resulting from these interruptions. You agree that we have no
            obligation to maintain continuous service availability and that we
            shall not be held responsible for service disruptions.
          </Normal>
          <div className="p-5" />
          <Big>No Liability for Generated Code or Applications</Big>
          <div className="p-3" />
          <Normal>
            You agree that CodeBlaze is not liable for any issues, errors, bugs,
            or damage that may result from the use, modification, or
            distribution of any code generated by the platform. This includes,
            but is not limited to:
          </Normal>
          <div className="p-3" />
          <Normal>
            - Integration issues with other software
            <br />- Bugs or security vulnerabilities in the generated code
            <br />- Incompatibility with third-party systems or APIs
            <br />- Loss of data, system failures, or performance degradation
          </Normal>
          <div className="p-5" />
          <Big>Limitation of Liability</Big>
          <div className="p-3" />
          <Normal>
            To the fullest extent permitted by applicable law, CodeBlaze and its
            affiliates, employees, agents, licensors, and suppliers shall not be
            liable for any direct, indirect, incidental, special, consequential,
            or punitive damages, including, but not limited to, loss of profits,
            data, business, or goodwill, arising from:
          </Normal>
          <div className="p-3" />
          <Normal>
            - Your use or inability to use the platform, Services, or any
            generated code - Any third-party content or services linked to or
            from the platform - Any security breaches, unauthorized access, or
            loss of data - System outages, service interruptions, or performance
            issues - Errors or inaccuracies in generated code - Business impacts
            such as project delays, increased development costs, or customer
            dissatisfaction
          </Normal>
          <div className="p-3" />
          <Normal>
            In no event shall CodeBlaze’s liability exceed the amount you have
            paid for the Services in the twelve months preceding the claim.
          </Normal>
          <div className="p-3" />
          <Big>Indemnification</Big>
          <div className="p-3" />
          <Normal>
            You agree to indemnify, defend, and hold harmless CodeBlaze, its
            affiliates, officers, directors, employees, and agents from and
            against any and all claims, damages, liabilities, losses, costs, or
            expenses (including legal fees) arising from:
          </Normal>
          <div className="p-3" />
          <Normal>
            - Your use of the Services
            <br />- Your violation of these Terms
            <br />- Infringement of third-party rights
            <br />- Misuse of code generated through our platform
            <br />- Any content you upload or share on the platform
          </Normal>
          <div className="p-3" />
          <Big>No Warranty for Code Generation and Services</Big>
          <div className="p-3" />
          <Normal>
            CodeBlaze does not warrant or guarantee the results of using our
            Services. You acknowledge that AI-generated code, despite its
            efficiency, may contain bugs, vulnerabilities, or other limitations
            that require human intervention and modification. We do not
            guarantee that the generated code will fully meet your expectations,
            performance requirements, or security standards.
          </Normal>
          <div className="p-3" />
          <Big>Security and Privacy</Big>
          <div className="p-3" />
          <Normal>
            CodeBlaze is committed to protecting your data and privacy in
            accordance with our Privacy Policy. However, no system is completely
            secure, and we do not warrant the security of the platform or your
            data. You understand that you are using the platform at your own
            risk, and CodeBlaze will not be liable for any data loss, breaches,
            or unauthorized access to your personal or business information.
          </Normal>
          <div className="p-3" />
          <Big>Force Majeure</Big>
          <div className="p-3" />
          <Normal>
            CodeBlaze will not be held liable for any delay or failure in the
            performance of its obligations under these Terms if the delay or
            failure is caused by events or circumstances beyond its reasonable
            control, including, but not limited to, acts of nature, government
            actions, wars, strikes, network failures, or other unforeseen
            events.
          </Normal>
          <div className="p-3" />
          <Big>Changes to the Disclaimer</Big>
          <div className="p-3" />
          <Normal>
            CodeBlaze reserves the right to update or modify this Disclaimer at
            any time without prior notice. The most current version will be
            posted on the website, and your continued use of the Services after
            such changes constitutes your acceptance of the updated Disclaimer.
          </Normal>
          <div className="p-3" />
          <Big>Governing Law and Dispute Resolution</Big>
          <div className="p-3" />
          <Normal>
            These Terms shall be governed by the laws of the United States of
            America. Any disputes arising from the use of the platform or
            Services shall be resolved in the competent courts of Delaware, USA.
            By using our Services, you consent to the jurisdiction and venue of
            these courts.
          </Normal>
          <div className="p-3" />
          <Big>Contact Information</Big>
          <div className="p-3" />
          <Normal>
            For any questions or concerns regarding this Disclaimer, please
            contact us at:
          </Normal>
          <div className="p-3" />
          <Normal>Email: support@codeblaze.ai</Normal>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
